import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Language } from '../../../redux/store/base/language';
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBBadge, MDBHamburgerToggler
} from "mdbreact";

// import asset
import "./NavbarPage.scss";
import Logo from "./../../../assets/images/icon/logo.svg";
import Makeup from "./../../../assets/images/icon/makeup.svg";
import LinkCustom from '../Custom/Link';


const NavbarPage = () => {
    const [isOpen, setIsOpen] = useState<boolean>();
    const [isScroll, setIsScroll] = useState<boolean>();

    const toggleCollapse = useCallback(() => {
        setIsOpen(state => !state);
    }, [setIsOpen]);

    const toggleScroll = useCallback((scroll) => {
        setIsScroll(scroll);
    }, [setIsScroll]);

    const handlerNavbar = useCallback(() => {
        window.scrollY > 0 ? toggleScroll(true) : toggleScroll(false);
    }, []);


    const dictionary = useSelector(
        (state: { lang: Language }) => state.lang.dictionary?.link
    );

    useEffect(() => {
        setIsOpen(false);
        setIsScroll(false);
        document.addEventListener('scroll', handlerNavbar);
        return () => {
            setIsOpen(null);
            setIsScroll(null);
            document.removeEventListener('scroll', handlerNavbar);
        }
    }, [])


    return <header>
        <MDBNavbar className={isScroll ? "scroll" : ""} expand="md" scrolling fixed="top">

            <MDBNavbarNav right>
                <MDBNavbarBrand>
                    <img src={Logo} />
                </MDBNavbarBrand>
            </MDBNavbarNav>

            <MDBHamburgerToggler color="#733189" id="hamburger1" onClick={toggleCollapse} />

            <MDBCollapse isOpen={isOpen} navbar>
                <MDBNavbarNav left>
                    <MDBNavItem>
                        <LinkCustom to="/" dictionaryTitle={dictionary?.home} />
                    </MDBNavItem>
                    <MDBNavItem>
                        <LinkCustom to="/service" dictionaryTitle={dictionary?.services} />
                        {/* <MDBDropdown>
                            <MDBDropdownToggle className="waves-effect waves-light" nav caret>
                                {dictionary?.services}
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                                <MDBDropdownItem>{dictionary?.cosmetic_services}</MDBDropdownItem>
                                <MDBDropdownItem>{dictionary?.hair_services}</MDBDropdownItem>
                                <MDBDropdownItem>{dictionary?.masks}</MDBDropdownItem>
                                <MDBDropdownItem>{dictionary?.body_services}</MDBDropdownItem>
                                <MDBDropdownItem>{dictionary?.skin_services}</MDBDropdownItem>
                                <MDBDropdownItem>{dictionary?.relaxation_services}</MDBDropdownItem>
                            </MDBDropdownMenu>
                        </MDBDropdown> */}
                    </MDBNavItem>
                    <MDBNavItem>
                        <LinkCustom to="/offers" dictionaryTitle={dictionary?.offers} />
                    </MDBNavItem>
                    <MDBNavItem>
                        <LinkCustom to="/blog" dictionaryTitle={dictionary?.blog} />
                    </MDBNavItem>
                    <MDBNavItem>
                        <LinkCustom to="/home#aboutUs" dictionaryTitle={dictionary?.aboutUs} />
                    </MDBNavItem>
                    <MDBNavItem>
                        <LinkCustom to="/home#signup" dictionaryTitle={dictionary?.signup} />
                    </MDBNavItem>
                    <MDBNavItem className="icon-badge">
                        <img src={Makeup} />
                        <MDBBadge pill color="danger">
                            <span>100</span>
                        </MDBBadge>
                    </MDBNavItem>
                </MDBNavbarNav>
            </MDBCollapse>
        </MDBNavbar>
    </header>
}


export default NavbarPage;